var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05364 0.549236C0.939145 0.820194 0 1.83651 0 3.90508V54.09C0 55.9925 0.732971 57.3625 2.11024 57.4942L2.1479 57.4552C2.78535 57.5317 3.50444 57.353 4.34969 56.8763C4.62435 56.722 5.29949 56.3433 6.29272 55.7862C6.72043 55.5463 7.20713 55.2733 7.74623 54.9709L30.5867 31.7758L1.32124 2.22423L2.16656 1.3871L31.4215 30.9281L40.5942 21.613L41.4419 22.4478L32.2587 31.7735L38.2519 37.8252C38.2806 37.809 38.3093 37.7928 38.338 37.7767C39.6319 37.0474 40.8642 36.3514 42.0126 35.7028C42.6642 35.3348 43.2888 34.9821 43.8823 34.6471L43.8855 34.6453C47.5725 32.5647 50.0576 31.1623 50.3556 31.0102C51.7329 30.2579 53.1559 28.2677 50.3556 26.722C49.4515 26.2359 44.5834 23.4934 38.3376 19.9575L38.3101 19.986C37.2659 19.4011 6.25605 2.03191 4.34923 0.990521C3.61956 0.545144 2.78613 0.417565 2.05364 0.549236ZM37.1775 38.4311L31.4239 32.6212L11.4769 52.8778C18.3521 49.0201 28.8329 43.1355 37.1775 38.4311Z",
    fill: "#00A3A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.dd9fc9bd4636744cce8ea716db37295d.svg";
export { ForwardRef as ReactComponent };